import React from 'react';
import './ErrorBoundary.css';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    console.error("Error caught by boundary:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleReturnToLogin = () => {
    // Clear any stored authentication and cache
    localStorage.removeItem('id_token');
    localStorage.removeItem('last_activity_timestamp');
    localStorage.removeItem('token_expiry_timestamp');
    sessionStorage.clear();
    
    // Redirect to login page with cache bypass
    window.location.href = '/signin?nocache=' + Date.now();
  }

  handleRefresh = () => {
    // Clear cache and reload
    sessionStorage.clear();
    window.location.reload(true);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <div className="error-boundary-card">
            <div className="error-boundary-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="64" height="64">
                <path fill="none" d="M0 0h24v24H0z"/>
                <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" fill="#f44336"/>
              </svg>
            </div>
            <h1 className="error-boundary-title">Something went wrong</h1>
            <p className="error-boundary-message">
              We're sorry, but the application has encountered an unexpected error.
            </p>
            <div className="error-boundary-actions">
              <button 
                className="error-boundary-button primary" 
                onClick={this.handleRefresh}
              >
                Refresh Page
              </button>
              <button 
                className="error-boundary-button secondary" 
                onClick={this.handleReturnToLogin}
              >
                Return to Login
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
